import { Flex, FlexProps } from 'vvs-uikit'

import { StepDotDiv } from './styles'

const StepDots = ({
  steps,
  currentStep,
  onClick,
  ...props
}: {
  steps: number
  currentStep: number
  onClick?: (clickedStep: number) => void
} & Omit<FlexProps, 'onClick'>) => {
  return (
    <Flex justifyContent="center" gap="8px" {...props}>
      {Array(steps)
        .fill(null)
        .map((_, i) => i + 1)
        .map((step) => (
          <StepDotDiv key={step} active={currentStep === step} onClick={() => onClick(step)} />
        ))}
    </Flex>
  )
}

export default StepDots
